import { createContext, useContext } from 'react';
import type { NodeKind } from './types';

export type FlowDisplayLanguage = 'en' | 'ja';

const FlowDisplayLanguageContext = createContext<FlowDisplayLanguage>('en');

export const FlowDisplayLanguageProvider = FlowDisplayLanguageContext.Provider;

export const useFlowDisplayLanguage = (): FlowDisplayLanguage =>
  useContext(FlowDisplayLanguageContext);

const nodeDisplayLabels: Record<NodeKind, Record<FlowDisplayLanguage, string>> = {
  start: { en: 'Start', ja: 'スタート' },
  end: { en: 'End', ja: 'エンド' },
  input: { en: 'Input', ja: '入力' },
  output: { en: 'Output', ja: '出力' },
  function: { en: 'Function', ja: '関数' },
  textEdit: { en: 'Text Edit', ja: '文字入力' },
  sayText: { en: 'Say Text', ja: '話す' },
  gesture: { en: 'Gesture', ja: 'ジェスチャー' },
  dance: { en: 'Dance', ja: 'ダンス' },
  qrScan: { en: 'QR Scan', ja: 'QR読み取り' },
  tof: { en: 'Dist Sensor', ja: '距離測定' },
  listen: { en: 'Listen', ja: '聞き取り' },
  if: { en: 'If', ja: 'もし' },
  switch: { en: 'Switch', ja: '分岐' },
  counter: { en: 'Counter', ja: 'カウンター' },
  coinFlip: { en: 'Coin Flip', ja: 'コイントス' },
  wait: { en: 'Wait', ja: '待つ' },
  randomChoice: { en: 'Random Choice', ja: 'くじびき' },
  keywordSwitch: { en: 'Keyword Switch', ja: 'キーワード分岐' },
  soundEffect: { en: 'Sound Effect', ja: '効果音' },
  light: { en: 'Light', ja: 'ライト' },
  mazeGoal: { en: 'At Goal?', ja: 'ゴールですか？' },
  customGesture: { en: 'Create', ja: '動きを作る' },
  walking: { en: 'Walking', ja: '歩行' },
};

export const getNodeDisplayLabel = (
  kind: NodeKind,
  language: FlowDisplayLanguage
): string => nodeDisplayLabels[kind]?.[language] ?? nodeDisplayLabels[kind]?.en ?? kind;
